import { useEffect, useState } from 'react';

let listeners = new Set();
let timer = null;

function start(periodMs) {
	if (timer) return;
	timer = setInterval(() => {
		for (const cb of listeners) cb(Date.now());
	}, periodMs);
}

function stop() {
	clearInterval(timer);
	timer = null;
}

export function useTicker(periodMs = 30_000) {
	const [, forceRender] = useState(0);

	useEffect(() => {
		function tick() {
			// increment so React rerenders
			forceRender((c) => c + 1);
		}

		listeners.add(tick);
		if (!timer) start(periodMs);

		return () => {
			listeners.delete(tick);
			if (listeners.size === 0) stop();
		};
	}, [periodMs]);

	return null; // just used to trigger re-renders
}
